export enum TransputType{
    Input = 1,
    Output = 2,
    Marker = 3,
    Nothing = 4,
  }